import React from "react";
import { ConfigProvider, App } from "antd";
import enUS from "antd/locale/en_US";
import deDE from "antd/locale/de_DE";
import { useTranslation } from "react-i18next";

interface AntdConfigProviderProps {
  children: React.ReactNode;
}

export const COLOR_PRIMARY = "#9A292B";
export const COLOR_PRIMARY_HOVER = "#9A292B";

export default function AntdConfigProvider({
  children,
}: AntdConfigProviderProps): React.ReactNode {
  const { i18n } = useTranslation();

  const getAntdLocale = () => {
    if (i18n.language === "de") {
      return deDE;
    }

    return enUS;
  };

  return (
    <ConfigProvider
      locale={getAntdLocale()}
      theme={{
        token: {
          fontFamily: "Roboto, Arial, sans-serif",
          colorPrimary: COLOR_PRIMARY,
          colorLink: COLOR_PRIMARY,
          colorLinkHover: COLOR_PRIMARY_HOVER,
          colorLinkActive: COLOR_PRIMARY,
        },
        // https://ant.design/docs/react/migrate-less-variables#how-to-use-component-token
        components: {
          Layout: {
            headerHeight: "var(--header-height)",
          },
          Segmented: {
            trackBg: "#0000000A",
          },
        },
      }}
    >
      <App>{children}</App>
    </ConfigProvider>
  );
}
